import { Result } from "antd";
import { ReactElement } from "react";

const EmailNotFoundView = (): ReactElement => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="URLの有効期限が消えました。必要に応じて管理者に連絡してください。"
    />
  );
};

export default EmailNotFoundView;
